/**
 * @generated SignedSource<<79e44f8f54ace5d85a6adf12c95bae32>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type IntegrationInvafreshCreateScreenMutation$variables = {
  screenHash: string;
};
export type IntegrationInvafreshCreateScreenMutation$data = {
  readonly store: {
    readonly activateIntegrationInvafresh: {
      readonly id: string;
    } | null;
  };
};
export type IntegrationInvafreshCreateScreenMutation = {
  response: IntegrationInvafreshCreateScreenMutation$data;
  variables: IntegrationInvafreshCreateScreenMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "screenHash"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "StoreMutations",
    "kind": "LinkedField",
    "name": "store",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "screenHash",
            "variableName": "screenHash"
          }
        ],
        "concreteType": "IntegrationInvafresh",
        "kind": "LinkedField",
        "name": "activateIntegrationInvafresh",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "IntegrationInvafreshCreateScreenMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "IntegrationInvafreshCreateScreenMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "c5ecb5a6297a29c92d6a952ec8882964",
    "id": null,
    "metadata": {},
    "name": "IntegrationInvafreshCreateScreenMutation",
    "operationKind": "mutation",
    "text": "mutation IntegrationInvafreshCreateScreenMutation(\n  $screenHash: String!\n) {\n  store {\n    activateIntegrationInvafresh(screenHash: $screenHash) {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "b8a0d49ecdd626925a20d6b5fe3ceacb";

export default node;
